"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _reactSelect = require("react-select");
/** @jsxRuntime classic */
/** @jsx jsx */

// These types are missing from react-select types for InputProps:
// https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/react-select/src/components/Input.d.ts

const Input = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return (0, _core.jsx)(_reactSelect.components.Input, (0, _extends2.default)({}, rest, {
    css: (0, _core.css)`
                padding-left: 6px;
                font-size: 13px;
                // Need to shift the top by a bit if we're in multiselect mode since we use a negative margin
                // fix to properly wrap the selection in MultiSelectValueContainer.
                position: relative;

                // Need to override the default line-height so we don't inherit the default 18px.
                line-height: 16px;

                ${rest.selectProps.isMulti ? "top: 4px; padding: 4px 0 6px 6px;" : ""}
            `
  }), children);
};
exports.Input = Input;
//# sourceMappingURL=Input.js.map